import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();

  if (loading || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[color:var(--paper)]" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[color:var(--ink-soft)]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Onboarding gate
  const onboarded = user.onboarding_completed === true;
  const onOnboarding = pathname === "/app/onboarding";
  if (!onboarded && !onOnboarding) return <Navigate to="/app/onboarding" replace />;
  if (onboarded && onOnboarding) return <Navigate to="/app" replace />;
  return children;
}
